import IndustryPageTemplate from "@/components/IndustryPageTemplate";

const RetailEcommerce = () => (
  <IndustryPageTemplate
    seoTitle="Retail and E-Commerce Freight | Varstar Alliance"
    seoDesc="Flexible freight that scales with demand. Peak season capacity."
    canonical="/industries/retail-ecommerce"
    h1={"Scale up. Ship out.\nKeep customers happy."}
    subtitle="Freight that flexes with your demand - not the other way around."
    industry="Retail & E-Commerce"
    problem="Retail shipping is a rollercoaster. Q4 volume can be 3x your average. Flash sales create overnight spikes. You need capacity on command."
    solutions={[
      { title: "Elastic carrier capacity" },
      { title: "Multi-DC distribution" },
      { title: "LTL consolidation" },
      { title: "Real-time tracking" },
      { title: "Pre-reserved peak season capacity" },
    ]}
    statBanner="3x capacity scaling during peak season - guaranteed."
    faqs={[
      { q: "Can you handle peak season volume?", a: "Yes. We pre-reserve capacity for peak season so you're never scrambling for trucks." },
      { q: "Do you offer LTL for smaller shipments?", a: "Absolutely. LTL consolidation is a core offering for retail clients." },
      { q: "How fast can you scale up?", a: "With our 40,000+ carrier network, we can scale capacity within 24 hours." },
      { q: "Do you handle multi-DC distribution?", a: "Yes. We coordinate complex distribution across multiple DCs." },
    ]}
  />
);

export default RetailEcommerce;
